import hsFetch from 'hellospa/hs-fetch';
import HfReactHelper from '../../../hellosign/components/hf-react-helper';
import { postMessage, messages } from 'common/utils/messages';

/* eslint-disable camelcase */
export type SaveEmbeddedRequestResponse = {
  success: boolean
  signature_request_id: string
  signature_request_info: {
    title: string
    message: string
    signatures: Array<{
      signer_name: string
      signer_email_address: string
      order: null | number
    }>
    cc_email_addresses: string[]
  }
}
export type SaveEmbeddedTemplateResponse = {
  success: boolean
  template_id: string
  template_status_id: string
  template_info: {
    title : string
    message : string
    signer_roles: Array<{
      name: string
      order: null | number
    }>
    cc_roles: string[]
  }
}
/* eslint-enable camelcase */

/**
 * WARNING: This type is incomplete. I'm only including enough functionality to
 * make Embedded work.
 */
export type SaveDataResponse = SaveEmbeddedRequestResponse | SaveEmbeddedTemplateResponse

export default function editorActions(
  csrfToken: string,
  csrfTokenAttachmentDelete: string,
  preLoadedTsmGroupKey: string,
) {

  async function loadData(cachedParamsToken: string) {
    // Fetch the data from the server
    const url = `/editor/getData?cached_params_token=${cachedParamsToken}`;
    const response = await hsFetch(url, {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    let data = [];
    if (response.status === 200) {
      data = (await response.json()).data;
    }

    return data;
  }

  async function loadAutoSuggestionData() {

    const autocompleteResponse = await hsFetch('/editor/asyncAutocomplete', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    return autocompleteResponse.json();
  }

  async function keepSessionAlive() {
    // keep session alive
    await hsFetch('/account/keepSessionAlive', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
  }

  async function deleteDocument(snapshotGuid: string) {
    if (snapshotGuid) {
      const formData = new FormData();
      formData.append('snapshot_guid', snapshotGuid);
      formData.append('csrf_token', csrfTokenAttachmentDelete);
      formData.append('preloaded_tsm_group_key', preLoadedTsmGroupKey);

      const response = await hsFetch('/attachment/delete', {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      if (result.error) {
        throw new Error(result.error);
      }

      // Posting message to event listener
      // to remove the deleted document from
      // the prep & send page
      postMessage({
        type: messages.USER_PREP_SEND_EDITOR_DELETE_DOC,
        guid: result.guid,
        parent_guid: result.parent_guid,
      }, window.parent.location.protocol + HfReactHelper.urlHelper(''));
    }
  }

  async function saveData(data: any): Promise<SaveDataResponse> {
    data.csrf_token = csrfToken;

    const response = await hsFetch('/editor/saveData', {
      credentials: 'same-origin',
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const res = await response.json();

    if (typeof res.template_info === 'string') {
      res.template_info = JSON.parse(res.template_info);
      res.template_info.signer_roles = JSON.parse(res.template_info.signer_roles);
      res.template_info.cc_roles = res.template_info.cc_roles
        ? JSON.parse(res.template_info.cc_roles)
        : null;
    }

    return res;
  }

  return {
    loadData,
    loadAutoSuggestionData,
    keepSessionAlive,
    deleteDocument,
    saveData,
  };
}
